import type { CSSProperties, FC } from 'react';

import Icon from '@/components/common/iconedLinks/Icon';

import styles from './Tag.ds.module.scss';

type TrailingAndEndingContent = {
  iconSrc: string;
  iconAlt: string;
}

type CommonProps = {
  size?: 'xs' | 'sm' | 'md';
  color?: 'white' | 'grey' | 'promo' | 'success' | 'golden';
  trailingContent?: TrailingAndEndingContent;
  endingContent?: TrailingAndEndingContent;
  content: React.ReactNode;
  onClick?: () => void;
  cursor?: string;
}

type InteractiveTagProps = CommonProps & {
  state?: 'primary';
  type?: 'interactive';
}

type PassiveTagProps = CommonProps & {
  state?: 'primary' | 'secondary';
  type?: 'passive';
}

type NavigationTagProps = CommonProps & {
  state?: 'secondary';
  type?: 'navigation';
}

export type TagDSProps = InteractiveTagProps | PassiveTagProps | NavigationTagProps;

export const TagDS: FC<TagDSProps> = ({
  content, trailingContent, endingContent, size = 'md', type = 'passive', color = 'white', onClick, cursor, state = 'primary'
}) => {
  const className = [
    styles[color],
    styles[size],
    styles[state],
    styles[type],
  ].join(' ');

  const iconSize = size === 'md' ? 24 : 16;

  return (
    <section
      className={className} style={{ '--cursor': `url(${cursor}) 16 16, pointer` } as CSSProperties}
      data-test-id="tag-container" data-testid="tag-container" onClick={onClick}
    >
      {!!trailingContent && (
        <Icon src={trailingContent.iconSrc} id="trailing-content"
          alt={trailingContent.iconAlt} width={iconSize} height={iconSize}
        />
      )}
      <div className={styles.content}>{content}</div>
      {!!endingContent && (
        <Icon src={endingContent.iconSrc} id="ending-content"
          alt={endingContent.iconAlt} width={iconSize} height={iconSize}
        />
      )}
    </section>
  );
};

export default TagDS;
